import clsx from 'clsx';
import { STATUS_LABELS, type Status } from '../../lib/berichten';

interface Props {
  status: Status | string;
  className?: string;
}

const COLORS: Record<Status, string> = {
  open: 'bg-amber-50 text-amber-800 border-amber-300',
  afgehandeld: 'bg-emerald-50 text-emerald-700 border-emerald-300',
};

export function BerichtStatusPill({ status, className }: Props) {
  const key = (status as Status) in COLORS ? (status as Status) : 'open';
  return (
    <span
      className={clsx(
        'inline-flex items-center text-[10px] px-1.5 py-0.5 rounded font-medium border',
        COLORS[key],
        className
      )}
    >
      {STATUS_LABELS[key]}
    </span>
  );
}
